"use client";

import React, { useEffect, useRef, useState } from "react";

import { useSearchContext } from "shared/contexts/SearchContext";
import { GuestSelectorDropdown } from "../../GuestSelectorDropdown";
import {
  ArrowDown,
  GuestSelectorWrapper,
  InputContent,
  InputWrapper,
} from "./styles";

import { ReactComponent as AdultsSvg } from "assets/svgs/adults.svg";
import { ReactComponent as BabiesSvg } from "assets/svgs/babies.svg";
import { ReactComponent as ChildrenSvg } from "assets/svgs/children.svg";
import { ReactComponent as DownChevron } from "assets/svgs/down-chevron.svg";

/**
 * Componente GuestSelectorWithInput (Desktop)
 *
 * Barra de seleção de hóspedes com dropdown.
 */
export const GuestSelectorWithInput: React.FC = () => {
  const { searchState, setAdults, setChildren, setBabies } = useSearchContext();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownVisible((prev) => !prev);
  };

  return (
    <GuestSelectorWrapper ref={wrapperRef}>
      <InputWrapper
        onClick={toggleDropdown}
        aria-label="Selecione os hóspedes"
        aria-expanded={isDropdownVisible}
      >
        <InputContent>
          <span>
            <AdultsSvg /> {searchState.adults}
          </span>
          <span>
            <ChildrenSvg /> {searchState.children}
          </span>
          <span>
            <BabiesSvg /> {searchState.babies}
          </span>
        </InputContent>
        <ArrowDown isOpen={isDropdownVisible}>
          <DownChevron />
        </ArrowDown>
      </InputWrapper>

      {isDropdownVisible && (
        <GuestSelectorDropdown
          adults={searchState.adults}
          children={searchState.children}
          babies={searchState.babies}
          onAdultsChange={setAdults}
          onChildrenChange={setChildren}
          onBabiesChange={setBabies}
          icons={{
            adults: <AdultsSvg />,
            children: <ChildrenSvg />,
            babies: <BabiesSvg />,
          }}
        />
      )}
    </GuestSelectorWrapper>
  );
};
